<template>
  <cs-app>
    <template v-slot:content>
      <div v-if="selectedClientBid !== null">
          <md-table class="lawyer-bids-table">
            <md-table-row>
              <md-table-head>Age</md-table-head>
              <md-table-head>Sex</md-table-head>
              <md-table-head>Years of Exp.</md-table-head>
              <md-table-head>Spoken Languages</md-table-head>
              <md-table-head>Firm Size</md-table-head>
              <md-table-head>Location</md-table-head>
            </md-table-row>

            <md-table-row>
              <md-table-cell>{{ selectedClientBid.lawyer.profile.ageGroup }}</md-table-cell>
              <md-table-cell>{{ selectedClientBid.lawyer.profile.sex }}</md-table-cell>
              <md-table-cell>{{ selectedClientBid.lawyer.profile.yearsOfExperience }}</md-table-cell>
              <md-table-cell>
                <ul>
                  <li v-for="language in selectedClientBid.lawyer.profile.spokenLanguages">
                    {{ language }}
                  </li>
                </ul>
              </md-table-cell>
              <md-table-cell>{{ selectedClientBid.lawyer.profile.firmSize }}</md-table-cell>
              <md-table-cell>{{ selectedClientBid.lawyer.profile.firmLocation }}</md-table-cell>
            </md-table-row>
          </md-table>

          <!-- Areas of Expertise -->
          <span class="md-sub-heading">Claimed Areas of Expertise</span>
          <ul>
            <li v-for="expertise in selectedClientBid.lawyer.profile.areasOfExpertise">
              {{ expertise }}
            </li>
          </ul>

          <!-- Cost Details -->
          <span class="md-sub-heading">Cost Details</span>
          <ul>
            <li v-for="costDetail in selectedClientBid.costDetails">
              {{ costDetail.label }}: {{ costDetail.amount }}{{ costDetail.rate }}
            </li>
          </ul>
          <md-button
            @click="backToCase"
            class="md-primary md-raised md-fixed md-bottom-right"
          >Back</md-button>
          <md-button
            v-if="!bidAlreadyAccepted"
            @click="confirmBidAcceptance"
            class="md-primary md-raised md-fixed md-bottom-right"
          >Accept Bid</md-button>

        <md-dialog :md-active.sync="showDialog" v-if="showDialog">
          <md-dialog-title>Are you sure you want to accept this bid?</md-dialog-title>
          <md-dialog-content>
            <p>
              First, we need you to enter your e-mail address. Rest assured, we do not keep your e-mail elsewhere within
              our system and we will never share it with third-parties for marketing/advertising purposes. This is a
              one-time, single-purpose use. If you make a mistake in entering this data, don’t worry – you will be able
              to come back to this page and correct it!
            </p>

            <p>
              <strong><em>
                Second, please note that you will no longer be able to accept other bids after you accept this bid.
              </em></strong>
            </p>

            <md-field :class="getValidationClass('email')">
              <label>E-mail</label>
              <md-input v-model="form.email"></md-input>
              <span class="md-error" v-if="!$v.form.email.required">The email is required</span>
              <span class="md-error" v-else-if="!$v.form.email.email">Invalid email</span>
            </md-field>
          </md-dialog-content>
          <md-dialog-actions>

            <div v-if="sendingEmail || acceptingBid">
              <span v-if="sendingEmail">Sending e-mail to lawyer...</span>
              <span v-else-if="acceptingBid">Accepting bid...</span>
              <md-progress-spinner  :md-diameter="30" :md-stroke="3" md-mode="indeterminate">
              </md-progress-spinner>
            </div>
            <div v-else>
              <md-button class="md-default" @click="showDialog = false">Cancel</md-button>
              <md-button class="md-primary" @click="acceptBid">Accept</md-button>
            </div>
          </md-dialog-actions>
        </md-dialog>

        <md-dialog :md-active="showSuccessDialog" v-if="showSuccessDialog">
          <md-dialog-title>Success!</md-dialog-title>
          <md-dialog-content>
            <p>
              You've successfully accepted this bid! You now can view the contact details of the lawyer
              who placed this bid. Feel free to reach out to them!
            </p>
            <md-dialog-actions>
              <md-button class="md-default" @click="showSuccessDialog = false">Close</md-button>
            </md-dialog-actions>
          </md-dialog-content>
        </md-dialog>
      </div>
    </template>
  </cs-app>
</template>

<script>
import CSApp from '@/components/CSApp'
import { mapGetters } from 'vuex'
import { clientBidService } from '@/services/clientBidService'
import { bidTransformer } from '@/data/bidTransformer'
import { setTimeout } from 'timers'
import { validationMixin } from "vuelidate"
import {
  required,
  email,
} from "vuelidate/lib/validators"

export default {
    name: 'ClientBidDetailsPage',
    components: {
      'cs-app': CSApp
    },
    mixins: [validationMixin],
    data () {
      return {
        showDialog: false,
        showSuccessDialog: false,
        bidAlreadyAccepted: false,
        sendingEmail: false,
        acceptingBid: false,
        lawyer: {},
        form: {
          email: '',
        }
      }
    },
    validations () {
      return {
        form: {
          email: {
            required,
            email
          }
        }
      }
    },
    computed: {
      ...mapGetters([
        'selectedClientBid'
      ])
    },
    created () {
      clientBidService(this.$http).for(this.$route.params.caseId).get(this.$route.params.bidId).then(response => {
        const bid = bidTransformer(response.data)
        this.$store.commit('addSelectedClientBid', bid)
      })
    },
    methods: {
      getValidationClass(fieldName) {

      const field = _.get(this.$v.form, fieldName);

      if (field) {
        return {
          "md-invalid": field.$invalid && field.$dirty
        };
      }
    },
      backToCase () {
        this.$router.push({
          name: 'cases.show',
          params: {
            id: this.$route.params.caseId
          }
        })
      },
      confirmBidAcceptance () {
        this.showDialog = true
      },
      acceptBid () {
        this.$v.$touch();

        if (this.$v.$invalid) {
          return;
        }

        this.acceptingBid = true
        this.$http
          .post(
            `${process.env.VUE_APP_API_URL}/cases/${this.$route.params.caseId}/bids/${this.$route.params.bidId}/accept`
          )
          .then(response => {
            this.acceptingBid = false
            this.showDialog = false
            this.$http.get(`${process.env.VUE_APP_API_URL}/lawyers/${this.selectedClientBid.lawyerId}`)
              .then(response => {
                this.lawyer = response.data
                this.sendEmail();
              }).catch(error => {
                console.log(error)
              })
          }).catch(error => {
            console.log(error)
            this.acceptingBid = false
            if (error.response.status === 403) {
              this.bidAlreadyAccepted = true
            }
          })
      },
      sendEmail () {
        this.sendingEmail = true;

        console.log('Sending email...', this.form.email);

        this.$http.post(
          `${process.env.VUE_APP_NETLIFY_FUNCTIONS_API}/sendMail`,
          {
            email: this.form.email,
            caseId: this.$route.params.caseId,
            lawyerEmail: this.lawyer.profile.email
          }
        ).then(response => {
          this.sendingEmail = false;
          setTimeout(() => {this.showSuccessDialog = true}, 500)
        }).catch(error => {
          console.log(error)
        })
      }
    }
}
</script>